import { Component, ChangeDetectionStrategy } from '@angular/core';
import {
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DraggableModalWrapperComponent } from '../../../../../../shared/components/modal/draggable-modal-wrapper/draggable-modal-wrapper.component';

@Component({
    selector: 'app-schedule-k-attachment-dialog',
    templateUrl: `./schedule-k-attachment-dialog.component.html`,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatDialogActions,
        MatDialogContent,
        MatDialogTitle,
        FormsModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        DraggableModalWrapperComponent,
    ],
})
export class ScheduleKAttachmentDialogComponent {
    constructor(
        private dialogRef: MatDialogRef<ScheduleKAttachmentDialogComponent>,
    ) {}

    close(): void {
        this.dialogRef.close(true);
    }
}
